module.exports = __webpack_public_path__ + "static/media/game.adfed61f.jpg";